module.exports = __webpack_public_path__ + "63a0e5fac2407d150a5e0ce7e78dbeb4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/mlk.png
// module id = 542
// module chunks = 0